import { render, staticRenderFns } from "./ReportsLoadTable.vue?vue&type=template&id=70ffc400&lang=pug"
import script from "./ReportsLoadTable.vue?vue&type=script&lang=js"
export * from "./ReportsLoadTable.vue?vue&type=script&lang=js"
import style0 from "./ReportsLoadTable.vue?vue&type=style&index=0&id=70ffc400&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports